module.exports = "../images/smallmouth-bass-fishing-lac-seul@2x.jpg?v=6a848bf";